<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Svelte functions
	import { createEventDispatcher } from 'svelte';
	//Stores
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Design system components
	import { Button, ButtonV2, Container, Modal, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';

	export let showModal = false;
	export let homeName = '';

	const dispatch = createEventDispatcher<{ confirm: void }>();

	const onConfirm = () => {
		showModal = false;
		dispatch('confirm');
	};
</script>

<Modal
	{showModal}
	on:close={() => (showModal = false)}
	title={capFirstChar($format('switch_home_confirm_title', { default: 'Switch home?' }))}
	removeScrollPadding
>
	<svelte:fragment slot="content">
		<Container padding="scrollPaddings">
			<Text>
				{$format('switch_home_confirm_message', {
					values: { homeName },
					default:
						'You will leave your current home and switch to "{homeName}". Do you want to continue?',
				})}
			</Text>
		</Container>
	</svelte:fragment>

	<div slot="footer" class="d-flex justify-content-end">
		{#if $showNewLayout}
			<ButtonV2 size="l" variant="secondary" class="mr-s" on:click={() => (showModal = false)}>
				{$format('button_cancel', { default: 'Cancel' })}
			</ButtonV2>
			<ButtonV2 size="l" variant="primary" on:click={onConfirm}>
				{capFirstChar($format('switch_home_confirm_cta', { default: 'Switch home' }))}
			</ButtonV2>
		{:else}
			<Button
				variant="secondary"
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
				responsiveSize={{ sm: 'm' }}
				on:click={() => (showModal = false)}
			>
				{$format('button_cancel', { default: 'Cancel' })}
			</Button>
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
				responsiveSize={{ sm: 'm' }}
				on:click={onConfirm}
			>
				{capFirstChar($format('switch_home_confirm_cta', { default: 'Switch home' }))}
			</Button>
		{/if}
	</div>
</Modal>
